var replaceall = require("replaceall")
export function decodeRichText (val) {
    
    val = replaceall('|*|', '"', val)
    val = replaceall('|**|', "'", val)
    
    return val
}

export function decodeImgSrc (val, base){
    val = replaceall('[%base%]', base, cosUseAccelerate(val))
    return val
}

export function getCookie (cname) {
    var name = cname + "="
    var ca = document.cookie.split(';')
    for(var i=0; i<ca.length; i++){
        var c = ca[i].trim()
        if (c.indexOf(name)==0) return c.substring(name.length,c.length)
    }
    return ""
}

export function setCookie (name, value, expDays, remove) {
    // Prevent repeatedly set same cookie
    if(getCookie(name).length > 1){
        return
    }

    var exp, expTime
    
    if(!remove){
        expTime = (((60 * 1000)*60)*24)*expDays
        exp = new Date()
        exp.setTime(exp.getTime() + expTime)
        document.cookie = name + "=" + value + ";" + "expires=" + exp.toGMTString()+";SameSite=Strict;"
    } else {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
    }
}

export function isMobile () {
    return screen.width < 480 ? true : false
}

export function isDark() {
    const themeMedia = window.matchMedia("(prefers-color-scheme: light)");
    if (themeMedia.matches) return false;
    else return true;
}

export function parseDiffImg(base, url){
    if(!url || url.length < 1) return null;
    return url.indexOf('cos') != -1 ? 'https://' + url : base + url
}

export function cosUseAccelerate(url) {
    return url.replace(/ap-hongkong/g, "accelerate");
}

export function isNativeZHCN() {
    const language = navigator.language || navigator.userLanguage; // navigator.userLanguage 是旧的API，为了兼容性考虑
  
    // 判断是否为简体中文，zh-CN 代表简体中文
    if (language === 'zh-CN') {
      return true;
    }
  
    // 可以进一步检查 navigator.languages 中是否包含简体中文
    if (navigator.languages && navigator.languages.includes('zh-CN')) {
      return true;
    }
  
    return false;
  }